<div class="gerenciar-visto-container">
    <div class="gerenciar-visto-layout">
        <aside class="gerenciar-visto-panel">
            <!--
                Mesmo desenho do card de protocolo dos Serviços/quadro kanban: foto, e ao lado dela
                protocolo/nome/CRM-UF como um bloco só. Estilo compartilhado em
                shared/styles/_protocolo-card.scss (ver gerenciar-visto.scss).
            -->
            <app-card-content [border]="false">
                <article class="protocolo-card">
                    <div class="protocolo-card-topo">
                        <div class="protocolo-card-identificacao">
                            <app-pessoa-avatar [idSolicitante]="idSolicitanteAvatar" [uf]="ufAvatar" [nome]="solicitanteDisplay" tamanho="xxxl" [clicavel]="true" (fotoSelecionada)="ampliarFoto($event)" />
                            <span class="protocolo-card-nomes">
                                <span class="protocolo-badge">#{{ protocoloAnoDisplay }}</span>
                                <strong class="protocolo-card-solicitante">{{ solicitanteDisplay }}</strong>
                                <span class="protocolo-card-documento">{{ crmUfOrigemDisplay }}</span>
                            </span>
                        </div>

                        <button type="button" class="btn-voltar" (click)="onVoltar()">Voltar</button>
                    </div>

                    <dl class="protocolo-card-dados">
                        <div class="protocolo-card-dado">
                            <dt><i class="pi pi-id-card" aria-hidden="true"></i> Tipo do visto</dt>
                            <dd>{{ tipoVistoDisplay }}</dd>
                        </div>
                    </dl>

                    <div class="protocolo-card-rodape">
                        <span class="protocolo-tag protocolo-tag--situacao" [ngClass]="classeSituacaoTag">{{ statusSolicitacao }}</span>
                    </div>
                </article>
            </app-card-content>
        </aside>

        <div class="gerenciar-visto-content">
            <article class="gerenciar-visto-form-card">
                <form [formGroup]="vistoTemporarioForm">
                    <app-card-content class="section-wrapper" [headerColor]="true" [icon]="'pi pi-info-circle'" [title]="'Informações'">
                        <div card-header class="gerenciar-visto-card-acoes">
                            <app-botao-acoes label="Ações" [iconPos]="EInconPos.LEFT" [items]="itensAcoesVisto" [destaque]="itensEdicao" [destaqueAtivo]="editando" [iconColumns]="2" [appCan]="roleVistoEditar" [appCanUf]="pessoa()?.uf" [permissaoUf]="pessoa()?.uf ?? null"></app-botao-acoes>
                        </div>

                        @if (isVisto90Fracionado) {
                            <div class="grid grid-cols-1 md:grid-cols-3 gap-3 mb-3">
                                <div class="field md:col-span-3">
                                    <label class="block mb-1">Doc. de Origem</label>
                                    <input pInputText formControlName="documentoOrigem" class="w-full" />
                                </div>
                            </div>
                        }

                        <div class="grid grid-cols-1 md:grid-cols-5 gap-3 mb-3">
                            <div class="field">
                                <label class="block mb-1">CPF / CNPJ Solicitante</label>
                                <input pInputText formControlName="solicitanteCpfCnpj" class="w-full" />
                            </div>
                            <div class="field">
                                <label class="block mb-1">UF Origem</label>
                                <input pInputText formControlName="ufOrigem" class="w-full" />
                            </div>
                            <div class="field">
                                <label class="block mb-1">CRM de Origem</label>
                                <input pInputText formControlName="crmOrigem" class="w-full" />
                            </div>
                            @if (isVisto90Fracionado) {
                                <div class="field">
                                    <label class="block mb-1">Requerente</label>
                                    <input pInputText formControlName="requerente" class="w-full" />
                                </div>
                                <div class="field">
                                    <label class="block mb-1">CPF / CNPJ Requerente</label>
                                    <input pInputText formControlName="requerenteCpfCnpj" class="w-full" />
                                </div>
                            }
                        </div>

                        <div class="field">
                            <label class="block mb-1">Finalidade</label>
                            <textarea pTextarea rows="3" formControlName="finalidade" class="w-full"></textarea>
                        </div>
                    </app-card-content>

                    <app-card-content class="section-wrapper" [headerColor]="false" [icon]="'pi pi-calendar'" [title]="'Período Solicitado'">
                        <div class="grid grid-cols-1 gap-3 items-center">
                            <div class="grid grid-cols-[1fr_auto_1fr] gap-2 items-end">
                                <div class="field mb-0">
                                    <label class="block mb-1">Início</label>
                                    <p-inputmask formControlName="periodoInicio" mask="99/99/9999" placeholder="DD/MM/AAAA" styleClass="w-full"></p-inputmask>
                                </div>
                                <div class="pb-2">à</div>
                                <div class="field mb-0">
                                    <label class="block mb-1">Fim</label>
                                    <p-inputmask formControlName="periodoFim" mask="99/99/9999" placeholder="DD/MM/AAAA" styleClass="w-full"></p-inputmask>
                                </div>
                            </div>
                        </div>
                    </app-card-content>

                    @if (isVisto90Fracionado) {
                        <app-card-content class="section-wrapper" [headerColor]="false" [icon]="'pi pi-users'" [title]="'Médicos Relacionados'">
                            <p-table [value]="medicosRelacionados()" [tableStyle]="{ 'min-width': '24rem' }" size="small">
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th class="w-4rem">UF</th>
                                        <th>Médico</th>
                                        <th class="w-10rem">CPF</th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-item>
                                    <tr>
                                        <td>{{ item.uf }}</td>
                                        <td>{{ item.medico }}</td>
                                        <td>{{ item.cpf }}</td>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="emptymessage">
                                    <tr>
                                        <td colspan="3" class="text-center">
                                            <div class="table-empty-state">
                                                <span class="table-empty-state-icon"><i class="pi pi-search"></i></span>
                                                <p class="table-empty-state-title">Nenhum médico relacionado.</p>
                                            </div>
                                        </td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </app-card-content>
                    }

                    <app-card-content class="section-wrapper" [headerColor]="false" [icon]="'pi pi-map-marker'" [title]="'Endereço de Contato'">
                        <div class="grid grid-cols-1 md:grid-cols-[8rem_1fr] gap-3 mb-3">
                            <div class="field">
                                <label class="block mb-1">CEP</label>
                                <p-inputmask formControlName="contatoCep" mask="99999-999" placeholder="00000-000" styleClass="w-full"></p-inputmask>
                            </div>
                            <div class="field">
                                <label class="block mb-1">Endereço</label>
                                <input pInputText formControlName="contatoEndereco" class="w-full" />
                            </div>
                        </div>

                        <div class="grid grid-cols-1 md:grid-cols-2 gap-3 mb-3">
                            <div class="field">
                                <label class="block mb-1">Bairro</label>
                                <input pInputText formControlName="contatoBairro" class="w-full" />
                            </div>
                            <div class="field">
                                <label class="block mb-1">Município</label>
                                <input pInputText formControlName="contatoMunicipio" class="w-full" />
                            </div>
                        </div>

                        <div class="grid grid-cols-1 md:grid-cols-[5rem_10rem] gap-3">
                            <div class="field">
                                <label class="block mb-1">DDD</label>
                                <p-inputmask formControlName="contatoDdd" mask="99" placeholder="00" styleClass="w-full"></p-inputmask>
                            </div>
                            <div class="field">
                                <label class="block mb-1">Telefone</label>
                                <p-inputmask formControlName="contatoTelefone" mask="99999-9999" [autoClear]="false" placeholder="00000-0000" styleClass="w-full"></p-inputmask>
                            </div>
                        </div>
                    </app-card-content>

                    <app-card-content class="section-wrapper" [headerColor]="false" [icon]="'pi pi-briefcase'" [title]="'Endereço de Trabalho'">
                        <div class="grid grid-cols-1 md:grid-cols-[8rem_1fr] gap-3 mb-3">
                            <div class="field">
                                <label class="block mb-1">CEP</label>
                                <p-inputmask formControlName="trabalhoCep" mask="99999-999" placeholder="00000-000" styleClass="w-full"></p-inputmask>
                            </div>
                            <div class="field">
                                <label class="block mb-1">Endereço</label>
                                <input pInputText formControlName="trabalhoEndereco" class="w-full" />
                            </div>
                        </div>

                        <div class="grid grid-cols-1 md:grid-cols-2 gap-3 mb-3">
                            <div class="field">
                                <label class="block mb-1">Bairro</label>
                                <input pInputText formControlName="trabalhoBairro" class="w-full" />
                            </div>
                            <div class="field">
                                <label class="block mb-1">Município</label>
                                <input pInputText formControlName="trabalhoMunicipio" class="w-full" />
                            </div>
                        </div>

                        <div class="grid grid-cols-1 md:grid-cols-[5rem_10rem] gap-3">
                            <div class="field">
                                <label class="block mb-1">DDD</label>
                                <p-inputmask formControlName="trabalhoDdd" mask="99" placeholder="00" styleClass="w-full"></p-inputmask>
                            </div>
                            <div class="field">
                                <label class="block mb-1">Telefone</label>
                                <p-inputmask formControlName="trabalhoTelefone" mask="99999-9999" [autoClear]="false" placeholder="00000-0000" styleClass="w-full"></p-inputmask>
                            </div>
                        </div>
                    </app-card-content>

                    <app-card-content class="section-wrapper" [headerColor]="false" [icon]="'pi pi-history'" [title]="'Outros Vistos Cadastrados'">
                        <p-table [value]="outrosVistosCadastrados()" [tableStyle]="{ 'min-width': '24rem' }" size="small">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th class="w-6rem">Situação</th>
                                    <th class="w-10rem">Data Início</th>
                                    <th class="w-10rem">Data Fim</th>
                                    <th class="w-6rem">Dias</th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-item>
                                <tr>
                                    <td>
                                        <span class="situacao-badge" [class]="'situacao-badge--' + situacaoOutroVistoSeveridade(item.apto)">{{ item.apto || '-' }}</span>
                                    </td>
                                    <td>{{ item.dataInicio }}</td>
                                    <td>{{ item.dataFim }}</td>
                                    <td>{{ item.dias }}</td>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="emptymessage">
                                <tr>
                                    <td colspan="4" class="text-center">
                                        <div class="table-empty-state">
                                            <span class="table-empty-state-icon"><i class="pi pi-search"></i></span>
                                            <p class="table-empty-state-title">Nenhum visto cancelado.</p>
                                        </div>
                                    </td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </app-card-content>
                </form>
            </article>
        </div>
    </div>

    <p-dialog appDialogoPadrao="pi pi-users" descricao="Confirme antes de gravar a decisão." [(visible)]="dialogConfirmacaoVisivel" [closable]="false" [style]="{ width: '28rem' }" [header]="tituloDialogConfirmacao">
        <p class="m-0">{{ mensagemDialogConfirmacao }}</p>

        <ng-template pTemplate="footer">
            <div class="flex justify-end gap-2">
                <p-button type="button" label="Cancelar" severity="secondary" (onClick)="onCancelarDialogAcao()"></p-button>
                <p-button type="button" label="Confirmar" (onClick)="onConfirmarDialogAcao()"></p-button>
            </div>
        </ng-template>
    </p-dialog>

    <!-- Foto ampliada do solicitante (mesmo padrão de zoom da Capa de PAT/Dívida Ativa). -->
    <p-dialog appDialogoPadrao="pi pi-image" descricao="Foto do cadastro, em tamanho ampliado." [(visible)]="fotoAmpliadaVisivel" [style]="{ width: 'fit-content' }" header="Visualização da Foto" [dismissableMask]="true">
        @if (fotoAmpliada(); as foto) {
            <div class="flex items-center justify-center p-2">
                <img [src]="foto" alt="Foto ampliada" style="width: 300px; height: 300px; object-fit: cover; border-radius: 8px" />
            </div>
        }
    </p-dialog>
</div>
